// DB entry point: platform-picked driver + first-run seed, exposed as a
// singleton promise so every store awaits the same initialized instance.

import { Platform } from 'react-native';

import { seedBaselineIfNeeded, seedIfNeeded } from './seed';
import { type DocStore } from './types';
import { createWebStore } from './web-store';

export { KV_HOUSEHOLD } from './seed';
export { LOCAL_ONLY_TABLES, TABLES } from './types';
export type { DocStore } from './types';

let dbPromise: Promise<DocStore> | null = null;

export function getDb(): Promise<DocStore> {
  if (!dbPromise) {
    dbPromise = (async () => {
      let store: DocStore;
      if (Platform.OS === 'web') {
        store = createWebStore();
      } else {
        // dynamic import keeps expo-sqlite out of the web startup path
        const { createSqliteStore } = await import('./sqlite-store');
        store = createSqliteStore();
      }
      await store.init();
      if (__DEV__) {
        // Demo data only while developing (Expo Go / web preview). Pilot and
        // store builds skip this so real users start with their own, empty data.
        await seedIfNeeded(store);
      }
      await seedBaselineIfNeeded(store);
      return store;
    })();
  }
  return dbPromise;
}
